const isGALoaded = false
const isPALoaded = false
const isAnalyticsLoaded = false
const hostname = typeof window !== 'undefined' && window.location.hostname
const application = {
  env: hostname === 'developer.paypal.com' ? 'prod' : 'dev',
  name:
    typeof window !== 'undefined' &&
    window.location.pathname.split('/')[1] === 'dashboard'
      ? 'dashboard'
      : 'docs',
}
const _window = window
const _body = 'body'
const cookieId = '_dxexp_'

export {
  isGALoaded,
  isPALoaded,
  isAnalyticsLoaded,
  hostname,
  application,
  _window,
  _body,
  cookieId,
}
